const isPhoneNumber = function() {
  // return {
  //   validate: function (input) {
  //     const phoneInput = input.value;
  //     //const phoneRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
  //
  //     const phoneRegex = /^\([0-9]{3}\) [0-9]{3}\-[0-9]{4}$/
  //
  //     if (phoneInput.match(phoneRegex)) {
  //       return { valid: true }
  //     }
  //
  //     return { valid: false }
  //   }
  // }
  //This is the new validation...ddd-ddd-dddd{anything for extensions}
  return {
    validate: function (input) {
      const phoneInput = input.value;
      const phoneRegex = /^(\d{3})-(\d{3})-(\d{4})(.*)$/;

      return { valid: phoneInput.match(phoneRegex) }
    }
  }

}

const isOptionalPhoneNumber = function () {
  return {
    validate: function (input) {
      const phoneInput = input.value;
      const phoneRegex = /^(\d{3})-(\d{3})-(\d{4})(.*)$/;


      return { valid: (phoneInput === '' || phoneInput.match(phoneRegex)) }
    }
  }
}

const isValidEmail = function() {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return {
    validate: function (input) {
      const email = input.value;
      return {valid: re.test(String(email).toLowerCase())};
    }
  }
}

const isOptionalEmail = function() {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return {
    validate: function (input) {
      const email = input.value;
      return {valid: email === '' || re.test(String(email).toLowerCase())};
    }
  }
}


const isValidZipCode = function() {
  const re = /^[0-9]{5}$/;

  return {
    validate: function (input) {
      const zip = input.value;
      return {valid: re.test(String(zip).toLowerCase())};
    }
  }
}

const isValid2DigitState = function() {
  const states =  [
    "AK", "AL", "AR", "AS", "AZ", "CA", "CO", "CT", "DC", "DE", "FL", "GA", "GU", "HI", "IA",
    "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MS", "MT", "NC",
    "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH", "OK", "OR", "PA", "PR", "RI", "SC", "SD",
    "TN", "TX", "UT", "VA", "VI", "VT", "WA", "WI", "WV", "WY"
  ];

  return {
    validate: function (input) {
      let state = input.value;
      if(state) {
        state=state.toUpperCase();
      }
      return {valid: states.findIndex(e => e === state) >= 0};
    }
  }
}

exports.validateFormDetails = function(form_id) {
  let data = {}
  let issues = false;

  //Do inputs and selects
  $("#"+form_id+" input, #"+form_id+" select").each(function( ) {
    let id = $(this).attr('id');
    let invalid = $(this).hasClass("is-invalid");  //having a name means it is a required field

    if(invalid) {
      issues = true;
    }
    if(id) {
      data[id] = $(this).val();
    }
  });

  if(issues) {
    return;
  }

  return data;
}

exports.setFormDetails = function(form_id, data) {
    //do input fields
    $("#"+form_id+" input").each(function( ) {
      let id = $(this).attr('id');
      $(this).val(data[id] ? data[id] : '');
    });

    //do select fields
    $("#"+form_id+" select").each(function( ) {
      let id = $(this).attr('id');
      if(data[id]) {
        $(this).val(data[id]);
      } else {
        this.selectedIndex = 0;
      }
    });
}

exports.initValidation = function (formId) {
  FormValidation.validators.checkOptionalPhoneNumber = isOptionalPhoneNumber;
  FormValidation.validators.checkOptionalEmailAddress = isOptionalEmail;
  FormValidation.validators.checkPhoneNumber = isPhoneNumber;
  FormValidation.validators.checkEmailAddress = isValidEmail;
  FormValidation.validators.checkZipCode = isValidZipCode;
  FormValidation.validators.check2DigitState = isValid2DigitState;

  let fieldsNeeded = {
    requiredField: {
      validators: {
        notEmpty: {
          message: 'Field is required'
        }
      }
    },
    optionalField: {
      validators: {
      }
    }

  };
  inputs = $("#" + formId + " input[name='optionalPhoneNumber']");
  if (inputs.length > 0) {
    fieldsNeeded['optionalPhoneNumber'] = {
      validators: {
        checkOptionalPhoneNumber: {
          message: "Please enter a valid phone number"
        }
      }
    };
  }
  inputs = $("#" + formId + " input[name='optionalEmail']");
  if (inputs.length > 0) {
    fieldsNeeded['optionalEmail'] = {
      validators: {
        checkOptionalEmailAddress: {
          message: "Please enter a valid email address"
        }
      }
    };
  }

  let inputs = $("#" + formId + " input[name='requiredPhoneNumber']");
  if (inputs.length > 0) {
    fieldsNeeded['requiredPhoneNumber'] = {
      validators: {
        checkPhoneNumber: {
          message: "Please enter a valid phone number"
        }
      }
    };
  }
  inputs = $("#" + formId + " input[name='requiredEmail']");
  if (inputs.length > 0) {
    fieldsNeeded['requiredEmail'] = {
      validators: {
        checkEmailAddress: {
          message: "Please enter a valid email address"
        }
      }
    };
  }

  inputs = $("#" + formId + " input[name='requiredZipCode']");
  if (inputs.length > 0) {
    fieldsNeeded['requiredZipCode'] = {
      validators: {
        checkZipCode: {
          message: "Please enter a valid zip code"
        }
      }
    };
  }

  inputs = $("#" + formId + " input[name='requiredState']");
  if (inputs.length > 0) {
    fieldsNeeded['requiredState'] = {
      validators: {
        check2DigitState: {
          message: "Please enter a valid 2-character state"
        }
      }
    };
  }

  inputs = $("#" + formId + " select[name='requiredOption']");
  if (inputs.length > 0) {
    fieldsNeeded['requiredOption'] = {
      validators: {
        notEmpty: {
          message: 'Please select an option'
        }
      }
    };
  }

  return FormValidation.formValidation(
    document.getElementById(formId),
    {
      fields: fieldsNeeded,
      plugins: {
        trigger: new FormValidation.plugins.Trigger(),
        bootstrap: new FormValidation.plugins.Bootstrap(),
        submitButton: new FormValidation.plugins.SubmitButton()
      }
    }
  );
}



// WEBPACK FOOTER //
// ./client/app/_helpers/formValidationUtil.js